import Vue from 'vue'
import axios from 'axios'
import API from '@/common/api'
import store from '..'
import keyutils from 'js-crypto-key-utils'
import rsa from 'js-crypto-rsa'

export default {
  namespaced: true,
  state: {
    loginId: null,
    isLogin: false,
    otavalid: null,
    frame: 'true'
  },
  mutations: {
    setSiteInfo (state, data) {
      if (data.add) {
        const { key, value } = data.add
        Vue.set(state, key, value)
      }
  
      if (data.remove) {
        const { key } = data.remove
        Vue.delete(state, key)
      }
    },
    setLogin (state, data) {
      const urlSearchParams = new URLSearchParams(window.location.search)
      urlSearchParams.delete('staff')
      const params = data ? `${urlSearchParams.toString()}&staff=${data}` : urlSearchParams.toString()
      const url = `?${params}${window.location.hash}`
      state.isLogin = data
      if (data) {
        window.history.replaceState(null, null, url)
      }
    },
    setLoginId (state, id) { // id는 고정하여 미노출 할 경우 (page setting)
      state.loginId = id || null
    }
  },
  actions: {
    async getOtaKey ({ state }, isRequired) {
      const siteid = state.site || null
      const spaceid = state.space || null
      isRequired = isRequired || (state.public && state.public === 'true')
      if (siteid && spaceid) {
        if (!isRequired && (state.k && !(state.otavalid && state.otavalid === 'false'))) {
          return state.k
        } else if (!isRequired && (!state.k || (state.otavalid && state.otavalid === 'false'))) { // 조회하면 안됨
          return
        } else {
          try {
            const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
              cmd: 'sc-ota',
              func: 'get-ota',
              siteid: siteid,
              spaceid: spaceid
            })
            const ota = res && res.data && res.data.message
            const location = window.location
            const searchParams = new URLSearchParams(window.location.search)
            // public인 경우 ota 파라미터 삭제 (매번 ota를 요청하여 전송)
            if (state.public === 'true') {
              searchParams.delete('k')
              searchParams.delete('otavalid')
              history.replaceState({}, null, `${location.origin}${location.pathname}?${searchParams.toString()}${location.hash}`)
              state.otavalid = null
              // Vue.delete(state, 'otavalid')
              state.k = ota
            } else if (!ota) {
              searchParams.set('otavalid', 'false')
              history.replaceState({}, null, `${location.origin}${location.pathname}?${searchParams.toString()}${location.hash}`)
              state.otavalid = 'false'
              // Vue.set(state, 'otavalid', 'false')
            } else {
              Vue.set(k, ota)
            }
            return ota
          } catch (ex) {
            if (ex && ex.response && ex.response.data && ex.response.data.status === 403) {
              state.otavalid = 'false'
            }
            return false
          }
        }
      }
    },
    async getVariable ({ state }, data) {
      const siteid = store.state.authentication.site
      const rid = store.state.authentication.rid
      const ota = state.public ? await store.dispatch('authentication/getOtaKey') : state.k
      const key = rid ? { rid: rid, siteid: siteid } : { ota: ota }
      // 임시 파라미터
      const params = new URLSearchParams(window.location.search)
      const testCase = params.get('test')
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-variable',
          func: 'get-values',
          ...key,
          variables: data,
          // 임시 파라미터
          ...testCase && {
            test: testCase
          }
        })
        return res.status === 200 && res.data ? res.data.message : res
      } catch (ex) {
        console.log(ex)
        return false
      }
    },
    async validateOtaKey ({ state }, data) {
      try {
        const otaKey = data.otaKey && `&ota=${data.otaKey}`
        const space = data.space && `&space=${data.space}`
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=is-key-valid${otaKey}${space}`)
        const isValid = res && res.data && res.data.message === 'ok'
        const location = window.location
        const searchParams = new URLSearchParams(window.location.search)
        if (isValid) {
          searchParams.delete('otavalid')
          history.replaceState({}, null, `${location.origin}${location.pathname}?${searchParams.toString()}${location.hash}`)
          state.otavalid = null
        } else {
          searchParams.set('otavalid', 'false')
          history.replaceState({}, null, `${location.origin}${location.pathname}?${searchParams.toString()}${location.hash}`)
          state.otavalid = 'false'
        }
        return isValid
      } catch (ex) {
        console.log(ex)
        return false
      }
    },
    async checkout ({ state }, otaKey) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=process-check-out&metakey=${state.metakey}&ota=${otaKey}`)
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return ex && ex.reponse && ex.response.data && ex.response.data.message
      }
    },
    async getMetaInfo ({ state }) {
      if (state.metakey && state.k) {
        try {
          const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-meta-info&metakey=${state.metakey}&ota=${state.k}`)
          state.metaInfo = res.data.message
          return res.data.message
        } catch (ex) {
          console.log(ex)
          return false
        }
      }
    },
    async getGuestType ({ state }) {
      const ota = state.public ? await store.dispatch('authentication/getOtaKey') : state.k
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-guest',
          func: 'get-guest-type',
          ota: ota
        })
        if (res && res.data && res.data.message) {
          store.state.siteInfo.guestType = res.data.message.guestType
          store.state.siteInfo.noPost = res.data.message.noPost // noPost: true ? 룸차지 불가
        }
        return res && res.data && res.data.message
      } catch (ex) {
        return false
      }
    },
    async supportCheckout ({ state }) {
      if (state.site) {
        const ota = state.public ? await store.dispatch('authentication/getOtaKey') : state.k
        try {
          const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=site-check-out-support&siteid=${state.site}&metakey=${state.metakey}&ota=${ota}`)
          // const isSupport = res.data.status === 200 ? res.data.message : false
          return res && res.data
        } catch (ex) {
          return false
        }
      }
    },
    // pre check
    async canCheckout ({ state }) {
      if (state.site) {
        const ota = state.public ? await store.dispatch('authentication/getOtaKey') : state.k
        try {
          const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=can-check-out&siteid=${state.site}&metakey=${state.metakey}&ota=${ota}`)
          return res.data
        } catch (ex) {
          console.log(ex)
          return false
        }
      }
    },
    setAuthInfo ({ state, commit }, data) {
      Object.keys(data).forEach(function (x) {
        commit('setSiteInfo', {
          add: {
            key: x,
            value: `${data[x]}`
          }
        })
        // state[x] = `${data[x]}`
      })
      if (!data.frame) {
        state.frame = 'true'
      }
      // state.frame = `${data.frame !== 'false'}`
      return true
    },
    async login ({ state, dispatch }, data) {
      /**
       * 백엔드에서는 privateKey 사용
       */
      const publicKey = '-----BEGIN PUBLIC KEY-----\n' +
      'MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB3vV2a31LS8bYVPDdQQK3w\n' +
      'T/+Uy8Ejuxoc+9OwQJroNVjtJbjvcZD0gKSQuFYtXB/tDzK9/lGxeQ4TfkSqesdy\n' +
      '31/KrZa54z24sNkbII3x6sY0aow87/eCNpVl3Fw0evqs3REmQUO6eHBgDeH1qk60\n' +
      'oUhYg1ZGySIpw6Di6/+OchQnRKjoCGfQ8HNefWt0f4JtDavGOsXI5UupK4Ol+9sd\n' +
      'XcwkwCQ3L8Cc86Dav+LuEqMNY1m72m8mwElT4faDaatY3056WMwJvAy2IfF2GmOg\n' +
      '3/XCCbhZ/jqajidMBxN0ciAH4jJuH6aNT0HiORpl9Rz78Du4jFSkBzHrz7go5B3f\n' +
      'AgMBAAE=\n' +
      '-----END PUBLIC KEY-----'
      /**
       * pem 형식의 키를 jwk 형식으로 컨버팅
       * publicKey -> keyObj -> jwkKey
       */
      const keyObj = new keyutils.Key('pem', publicKey)
      const jwkKey = await keyObj.export('jwk')
      const authInfo = store.state.authentication
      const userData = {
        id: data.uid,
        pw: data.pw
      }
      /**
       * 로그인 정보 객체
       * -> string
       * -> Uint8Array
       * -> base64
       */
      let dataStr = JSON.stringify(userData)
      const encdoer = new TextEncoder()
      const bytes = encdoer.encode(dataStr)
      const encoded = await rsa.encrypt(bytes, jwkKey, 'SHA-256')
      const b64encoded = btoa(String.fromCharCode.apply(null, encoded))
      return axios.post(`${API.BASE_URL}/castit/viewer`, {
        cmd: 'sc-security',
        func: 'login',
        siteid: authInfo.site,
        spaceid: authInfo.space,
        ota: authInfo.k,
        data: b64encoded
      }).then(res => {
        return res
      }).catch((ex) => {
        // alert(ex)
        console.log(ex)
        return ex.response
      })
    },
    logout ({ state }) {
      localStorage.clear()
      state.requestId = null
      state.userInfo = null
      state.accesstoken = null
      state.apikey = null
      return true
    },
    async getExpressCheckinInfo ({ state, dispatch }) {
      if (state.site) {
        try {
          const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-checkin-info&siteid=${state.site}`)
          // const isSupport = res.data.status === 200 ? res.data.message : false
          return res.data.message
        } catch (ex) {
          return false
        }
      }
    },
    async checkExpressCheckein ({ state, dispatch }, rid) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-check-in',
          func: 'check-submit',
          siteid: siteInfo.site,
          rid: rid
        })
        return res.data.message
      } catch (ex) {
        return ex.response
      }
    },
    async smartlink ({ state, dispatch }, data) {
      const siteid = state.site
      const spaceid = state.space
      axios.defaults.headers.common['x-api-key'] = 'nukk2XeIFU3j1LBbX4ijA8tNyrKGmBPB5CUp0I1W'
      try {
        const res = await axios.post(`${API.BASE_URL}/stayguardian/smartlink`, {
          cmd: 'cmd-event',
          status: 'in',
          siteid: siteid,
          spaceid: spaceid,
          async: false,
          payload: {
            stayAfter: data.in,
            stayBefore: data.out
          }
        })
        return res.data
      } catch (ex) {
        console.error('error:', ex)
        return false
      }
    }
  },
  getters: {
    getAuthInfo: state => state,
    getMetaInfo: state => state.metaInfo,
    isLogin: state => state.isLogin,
    isAuth: state => state.space && state.k && !(state.otavalid && state.otavlid !== 'false')
  }
}
